var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "core-js/modules/es6.regexp.to-string", "core-js/modules/es6.date.to-string", "core-js/modules/es6.object.to-string", "@babel/runtime-corejs2/core-js/reflect/construct", "@babel/runtime-corejs2/helpers/extends", "core-js/modules/es6.array.fill", "@babel/runtime-corejs2/helpers/classCallCheck", "@babel/runtime-corejs2/helpers/createClass", "@babel/runtime-corejs2/helpers/assertThisInitialized", "@babel/runtime-corejs2/helpers/inherits", "@babel/runtime-corejs2/helpers/possibleConstructorReturn", "@babel/runtime-corejs2/helpers/getPrototypeOf", "@babel/runtime-corejs2/helpers/defineProperty", "react", "prop-types", "classnames", "../../Teasers/TeaserShow/TeaserShow", "../../Club/TeaserSubscribe/TeaserSubscribe", "../../UI/Button/Button", "../../UI/TitlesElement/TitlesElement"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("core-js/modules/es6.regexp.to-string"), require("core-js/modules/es6.date.to-string"), require("core-js/modules/es6.object.to-string"), require("@babel/runtime-corejs2/core-js/reflect/construct"), require("@babel/runtime-corejs2/helpers/extends"), require("core-js/modules/es6.array.fill"), require("@babel/runtime-corejs2/helpers/classCallCheck"), require("@babel/runtime-corejs2/helpers/createClass"), require("@babel/runtime-corejs2/helpers/assertThisInitialized"), require("@babel/runtime-corejs2/helpers/inherits"), require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"), require("@babel/runtime-corejs2/helpers/getPrototypeOf"), require("@babel/runtime-corejs2/helpers/defineProperty"), require("react"), require("prop-types"), require("classnames"), require("../../Teasers/TeaserShow/TeaserShow"), require("../../Club/TeaserSubscribe/TeaserSubscribe"), require("../../UI/Button/Button"), require("../../UI/TitlesElement/TitlesElement"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.es6Regexp, global.es6Date, global.es6Object, global.construct, global._extends, global.es6Array, global.classCallCheck, global.createClass, global.assertThisInitialized, global.inherits, global.possibleConstructorReturn, global.getPrototypeOf, global.defineProperty, global.react, global.propTypes, global.classnames, global.TeaserShow, global.TeaserSubscribe, global.Button, global.TitlesElement);
    global.TeasersList = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _es6Regexp, _es6Date, _es6Object, _construct, _extends2, _es6Array, _classCallCheck2, _createClass2, _assertThisInitialized2, _inherits2, _possibleConstructorReturn2, _getPrototypeOf2, _defineProperty2, _react, _propTypes, _classnames, _TeaserShow, _TeaserSubscribe, _Button, _TitlesElement) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _construct = _interopRequireDefault(_construct);
  _extends2 = _interopRequireDefault(_extends2);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _assertThisInitialized2 = _interopRequireDefault(_assertThisInitialized2);
  _inherits2 = _interopRequireDefault(_inherits2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _react = _interopRequireWildcard(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _classnames = _interopRequireDefault(_classnames);
  _TeaserShow = _interopRequireDefault(_TeaserShow);
  _TeaserSubscribe = _interopRequireDefault(_TeaserSubscribe);
  _Button = _interopRequireDefault(_Button);
  _TitlesElement = _interopRequireDefault(_TitlesElement);

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

  var components = {
    TeaserShow: _TeaserShow.default,
    TeaserSubscribe: _TeaserSubscribe.default
  };

  var TeasersList = /*#__PURE__*/function (_PureComponent) {
    (0, _inherits2.default)(TeasersList, _PureComponent);

    var _super = _createSuper(TeasersList);

    function TeasersList(props) {
      var _this;

      (0, _classCallCheck2.default)(this, TeasersList);
      _this = _super.call(this, props);
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onLoadMoreClick", function () {
        _this.props.onLoadMoreClick();
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "init", function (root) {
        _this.root = root;
      });
      _this.focusTeaserIndex = -1;
      return _this;
    }

    (0, _createClass2.default)(TeasersList, [{
      key: "UNSAFE_componentWillReceiveProps",
      value: function UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.teasers.length !== nextProps.teasers.length) {
          this.focusTeaserIndex = this.props.teasers.length;
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        if (this.focusTeaserIndex >= 0 && this.props.onLoadMoreClick) {
          var lastTeaserIndex = this.focusTeaserIndex;
          var teasers = this.root.querySelectorAll('.teasers-list__teaser > div > a'); // #accessibility
          // keep a logical keyboard navigation when some new teasers are loaded

          if (teasers.length > lastTeaserIndex) {
            teasers[lastTeaserIndex].focus();
          }

          this.focusTeaserIndex = -1;
        }
      }
    }, {
      key: "getTeasers",
      value: function getTeasers() {
        return this.props.placeholders > 0 ? this.props.teasers.concat(Array(this.props.placeholders).fill(0).map(function (value, index) {
          return {
            duration: 1,
            id: "placeholder-".concat(index),
            kind: '',
            placeholder: true,
            title: '-'
          };
        })) : this.props.teasers;
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            hasNextPage = _this$props.hasNextPage,
            labels = _this$props.labels,
            onFavoriteClick = _this$props.onFavoriteClick,
            onLoadMoreClick = _this$props.onLoadMoreClick,
            onTeaserClick = _this$props.onTeaserClick,
            withHighlight = _this$props.withHighlight,
            modifier = _this$props.modifier;
        return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
          ref: this.init,
          className: (0, _classnames.default)('teasers-list', modifier && "teasers-list--".concat(modifier), {
            'with-highlight': withHighlight
          })
        }, this.getTeasers().map(function (teaser, key) {
          var GenericTeaser;

          switch (teaser.kind) {
            case 'SUBSCRIBE':
              GenericTeaser = components.TeaserSubscribe;
              break;

            default:
              GenericTeaser = components.TeaserShow;
              break;
          }

          return /*#__PURE__*/_react.default.createElement("div", {
            className: "teasers-list__teaser",
            key: teaser.id
          }, /*#__PURE__*/_react.default.createElement(GenericTeaser, (0, _extends2.default)({
            onFavoriteClick: onFavoriteClick,
            onTeaserClick: onTeaserClick,
            titlesElement: /*#__PURE__*/_react.default.createElement(_TitlesElement.default, {
              isPlaceholder: teaser.placeholder > 0,
              display: withHighlight && key === 0 ? 'BIG' : '',
              subtitle: teaser.subtitle,
              title: teaser.title
            })
          }, teaser)));
        })), onLoadMoreClick && hasNextPage && /*#__PURE__*/_react.default.createElement("div", {
          className: "teasers-list__more"
        }, /*#__PURE__*/_react.default.createElement(_Button.default, {
          ariaLabel: "".concat(labels.seeMore, " : ").concat(labels.showMore),
          className: "next-button--outline",
          label: labels.loadMore,
          onClick: this.onLoadMoreClick
        })));
      }
    }]);
    return TeasersList;
  }(_react.PureComponent);

  TeasersList.propTypes = {
    hasNextPage: _propTypes.default.bool,
    labels: _propTypes.default.shape({
      loadMore: _propTypes.default.string,
      seeMore: _propTypes.default.string,
      showMore: _propTypes.default.string
    }),
    onFavoriteClick: _propTypes.default.func,
    onTeaserClick: _propTypes.default.func,
    onLoadMoreClick: _propTypes.default.func,
    placeholders: _propTypes.default.number,
    teasers: _propTypes.default.arrayOf(_propTypes.default.shape()),
    withHighlight: _propTypes.default.bool,
    modifier: _propTypes.default.string
  };
  TeasersList.defaultProps = {
    hasNextPage: false,
    labels: {
      loadMore: 'Load more',
      seeMore: 'See more',
      showMore: 'show more video'
    },
    onFavoriteClick: function onFavoriteClick() {},
    onTeaserClick: function onTeaserClick() {},
    placeholders: 0,
    teasers: [],
    withHighlight: false
  };
  var _default = TeasersList;
  _exports.default = _default;
});